const home = {
  hero: {
    pillBadge: "Водеща Дентална Клиника в България",
    title: {
      prefix: "Трансформираме Усмивки,",
      emphasis: "Променяме Животи",
    },
    description:
      "Получете дентално обслужване от световна величина с нашия екип от висококвалифицирани специалисти. Ние съчетаваме модерни технологии с персонализирани планове за лечение, за да създадем перфектната усмивка, която заслужавате.",
    ctas: {
      primary: "Запишете Час",
      secondary: "Разгледайте Услугите",
    },
    specialOffer: {
      guaranteeLabel: "ГОДИНИ ГАРАНЦИЯ",
      price: "2300 €",
      priceLabel: "All on 4",
      bullets: [
        "Премиум Качество",
        "Цялостно Решение",
        "Експертна Грижа",
        "Безплатна Консултация",
      ],
    },
    floatingStats: {
      experience: { small: "Години", large: "Опит" },
      patients: { small: "Щастливи", large: "Пациенти" },
    },
  },
  about: {
    title: "ЗА НАС",
    description:
      "Нашият екип е посветен в предоставянето на изключително/перфектно дентално обслужване с внимание към детайла",
    imageAlt: "Елит Дентал Солюшънс рентгенова технология",
    badges: ["Модерна Технология", "Експертен Екип"],
    paragraphs: [
      "Добре дошли в Елит Дентал Солюшънс, водеща дентална клиника в София, България. Нашият екип от високо опитни и квалифицирани зъболекари и дентални техници, с над 10 години професионален опит, е отдаден на предоставянето на изключително дентално обслужване както на местни, така и на международни пациенти.",
      "Гордеем се с използването на най-новите постижения в денталната технология, за да осигурим възможно най-доброто обслужване за нашите пациенти. С над 50 сертификата и богат опит в работата с международни пациенти, ние предлагаме пълен спектър от дентални услуги, за да отговорим на вашите нужди и да ви помогнем да постигнете красива усмивка.",
    ],
    checkBullets: [
      "Най-съвременно дентално оборудване и технологии",
      "Многоезичен персонал за международни пациенти",
      "Персонализирани планове за лечение за всеки пациент",
      "Цялостни услуги за дентален туризъм",
    ],
    cta: "Запишете Консултация",
    stats: [
      {
        value: "10+",
        title: "Години Опит",
        description: "Над десетилетие изключително дентално обслужване",
      },
      {
        value: "5000+",
        title: "Усмихнати Пациенти",
        description: "Доволни пациенти от цял свят",
      },
      {
        value: "20+",
        title: "Майсторски Сертификата",
        description: "Висококвалифицирани дентални специалисти в различни области на денталната медицина",
      },
      {
        value: "15",
        title: "Дентални Специалисти",
        description: "Се грижат за вашето дентално здраве",
      },
    ],
  },
  services: {
    heading: "НАШИТЕ УСЛУГИ",
    description:
      "Цялостна дентална грижа с внимание към всеки детайл и персонален подход",
    learnMore: "Научете повече",
    contactCta: "Свържете се с нас",
    items: {
      implantology: {
        title: "ИМПЛАНТОЛОГИЯ",
        description:
          "Нашата дентална клиника предлага висококачествени, дълготрайни зъбни импланти, които гарантират естествен вид и усещане, съчетавайки се перфектно с естествените ви зъби и значително подобрявайки цялостното ви орално здраве.",
        imageAlt: "Имплантология",
      },
      endodontics: {
        title: "ЕНДОДОНТИЯ",
        description:
          "Използваме щадяща процедура за лечение на коренови канали. В резултат на това минимизираме дискомфорта на пациента и запазваме естествената красота на вашата усмивка, докато възстановяваме увредените или инфектирани зъби и възвръщаме тяхната функция и здраве.",
        imageAlt: "Ендодонтия",
      },
      "oral-surgery": {
        title: "ОРАЛНА ХИРУРГИЯ",
        description:
          "Нашата клиника предлага минимално инвазивни екстракции, както и цялостна терапия за редица лицеви и дентални проблеми с акцент върху възстановяването на оралното здраве, комфорта на пациента и естетиката.",
        imageAlt: "Орална Хирургия",
      },
      periodontology: {
        title: "ПАРОДОНТОЛОГИЯ",
        description:
          "Нашата клиника предлага специализирано лечение и грижа за венците, фокусирайки се върху превенцията, диагностиката и лечението на пародонтални заболявания за подобряване на оралното здраве и цялостното благосъстояние.",
        imageAlt: "Пародонтология",
      },
      orthodontics: {
        title: "ОРТОДОНТИЯ",
        description:
          "В нашата клиника се предлагат експертни лечения за неправилно подредени зъби. Използваме съвременни методи, и всеки план за лечение е персонализиран, за да гарантира най-добрия възможен резултат за нашите пациенти—подобрявайки както общия им външен вид, така и оралното им здраве.",
        imageAlt: "Ортодонтия",
      },
      bonding: {
        title: "БОНДИНГ",
        description:
          "В нашата клиника експертно нанасяме композитна смола върху зъбите с цел подобряване на техния външен вид. За безупречен, визуално красив завършек, който повишава вашето самочувствие и усмивка, съчетаваме смолата с цвета на естествените ви зъби.",
        imageAlt: "Бондинг",
      },
      prosthetics: {
        title: "ПРОТЕТИКА",
        description:
          "Нашият дентален център се специализира в предоставянето на заместващи решения за липсващи зъби, използвайки персонализирани мостове или протези. Тези протетични устройства са прецизно проектирани не само за възстановяване на функцията, но и за подобряване на естетиката на вашата усмивка.",
        imageAlt: "Протетика",
      },
      cariesology: {
        title: "КАРИЕСОЛОГИЯ",
        description:
          "Предлагаме цялостна превенция и фокусирано лечение на зъбен кариес, интегрирайки обучение на пациента, рутинни прегледи и модерна диагностика за осигуряване на ефективна грижа и дългосрочно орално здраве.",
        imageAlt: "Кариесология",
      },
      "teeth-whitening": {
        title: "ИЗБЕЛВАНЕ НА ЗЪБИ",
        description:
          "Постигнете по красива и сияйна усмивка с процедурата по избелване на зъби. Нашите методи за максимално щадящи и ефективни за зъбите, като премахваме петна и обезцветявания по зъбите.Така ще подобрим денталната естетика и вашето самочувствие.",
        imageAlt: "Избелване на Зъби",
      },
      "dental-tourism": {
        title: "ДЕНТАЛЕН ТУРИЗЪМ",
        description:
          "Преводачи, транспорт и съдействие за настаняване—просто резервирайте при нас и нашият отдаден екип ще се погрижи за всеки детайл, осигурявайки безпроблемно изживяване, съобразено с вашите нужди.",
        imageAlt: "Дентален Туризъм",
      },
    },
  },
  testimonials: {
    heading: "ДОВОЛНИ ПАЦИЕНТИ",
    subheading: "Вижте какво споделят нашите пациенти за своя опит с нас",
    google: {
      title: "Google Отзиви",
      ratingValue: "5.0",
      countLabel: "(63 отзива)",
      readAll: "Прочетете всички отзиви",
    },
    carousel: {
      prevAria: "Предишен отзив",
      nextAria: "Следващ отзив",
    },
    metrics: {
      satisfaction: "Степен на удовлетвореност",
      positive: "Положителни отзиви",
      countries: "Обслужени държави",
    },
    items: {
      google: {
        g1: {
          content:
            "Нищо по-малко от перфектно не е достатъчно за тази клиника. Вниманието им към детайла е ненадминато. Персоналът е изключително професионален и същевременно загрижен. Всички говорят отлично английски.",
          name: "Гари Гарисайд",
          timeAgo: "преди 4 седмици",
          initial: "Г",
        },
        g2: {
          content:
            "Имах огромното удоволствие да получа лечение в Elite Dental Solutions под грижите на д-р Хаджиалиш и не бих могъл да бъда по-въодушевен от резултатите. Избрах процедурата All-on-4 и от самото начало се чувствах в сигурни ръце.",
          name: "Олен Ср12",
          timeAgo: "преди 2 месеца",
          initial: "О",
        },
        g3: {
          content:
            "Клиниката беше безупречна. Лекарите са приятелски настроени и ефективни. Много съм доволен от резултатите. Не можеше да има по-добра грижа.",
          name: "Лоз Борг",
          timeAgo: "преди 3 месеца",
          initial: "Л",
        },
      },
      regular: {
        r1: {
          content:
            "Бях притеснена за поставянето на зъбни импланти, но екипът на Elite Dental Solutions направи целия процес гладък и без стрес. От първата консултация до крайния резултат, те бяха професионални, грижовни и внимателни. Сега имам красива усмивка, с която се гордея, и не бих могла да бъда по-щастлива от резултата!",
          name: "Лин М.",
          location: "Великобритания",
        },
        r2: {
          content:
            "Посетих Elite Dental Solutions за избелване на зъби преди сватбата си и резултатите бяха невероятни! Персоналът беше толкова приятелски настроен и наистина отделиха време да ми обяснят процедурата. Зъбите ми са с няколко нюанса по-светли и се чувствах толкова уверена в големия си ден. Благодаря ви, че направихте усмивката ми перфектна за снимки!",
          name: "Георги Л.",
          location: "Германия",
        },
        r3: {
          content:
            "След години на справяне със зъбна чувствителност и проблеми с венците, най-накрая намерих решение в Elite Dental Solutions. Техният задълбочен подход към лечението ми и персонализираната грижа, която получих, направиха голяма разлика. Сега мога да се храня и усмихвам без болка и съм толкова благодарен за техния опит и доброта.",
          name: "Алекс Д.",
          location: "Италия",
        },
        r4: {
          content:
            "След като избягвах денталното лечение години наред поради тревожност, бях изумена колко комфортно ме накара да се чувствам екипът на Elite Dental Solutions. Те бяха търпеливи, разбиращи и обясниха всичко ясно. Качеството на работата е изключително и за първи път в живота си не се страхувам да отида на зъболекар!",
          name: "Сара К.",
          location: "Франция",
        },
        r5: {
          content:
            "Като човек, който пътува специално от чужбина за дентално лечение, не бих могъл да бъда по-впечатлен от Elite Dental Solutions. Те организираха всичко - от посрещане на летището до препоръки за настаняване. Самото дентално лечение беше първокласно, а спестяванията в сравнение с моята страна направиха пътуването повече от оправдано.",
          name: "Джеймс У.",
          location: "САЩ",
        },
      },
    },
  },
  gallery: {
    heading: "ФОТО ГАЛЕРИЯ",
    subheading:
      "Разгледайте нашата колекция от красиви трансформации на усмивки",
    closeAria: "Затвори галерията",
    prevAria: "Предишна снимка",
    nextAria: "Следваща снимка",
    items: {
      i1: { alt: "Интериор на клиника Elite Dental Solutions", category: "Клиника" },
      i3: { alt: "Съвременно дентално оборудване", category: "Оборудване" },
      i4: { alt: "Модерна дентална технология", category: "Оборудване" },
      i5: { alt: "Кабинет за дентални консултации", category: "Клиника" },
      i6: { alt: "Рецепция на денталната клиника", category: "Клиника" },
      i7: { alt: "Модерна рентгенова технология", category: "Технология" },
      i8: { alt: "Среда в денталната практика", category: "Клиника" },
      i9: { alt: "Модерно дентално оборудване", category: "Клиника" },
      i10: { alt: "Модерно работно пространство", category: "Оборудване" },
      i11: { alt: "Професионална дентална установка", category: "Оборудване" },
      i12: { alt: "Съвременен дентален кабинет", category: "Клиника" },
    },
  },
  contact: {
    heading: "СВЪРЖЕТЕ СЕ С НАС",
    subheading:
      "Тук сме, за да отговорим на вашите въпроси и да ви помогнем да запишете час",
    cardTitle: "За контакт",
    labels: {
      phone: "Телефон",
      email: "Имейл",
      address: "Адрес",
      workingHours: "Работно време",
    },
    phone: { telHref: "+359879800430", display: "+359 879 800 430" },
    email: { value: "info@elitedentalsolutions.eu" },
    address: {
      line1: "ж.к. Манастирски ливади, бл. Б 65,",
      line2: "1404 София, България",
    },
    workingHours: {
      line1: "Понеделник - Петък: 9:00 - 19:00",
      line2: "Събота: По предварително записване",
    },
    stickyCallText: "Обади се сега",
    form: {
      title: "Форма за контакт",
    },
  },
  contactForm: {
    fieldLabels: {
      firstName: "Име*",
      lastName: "Фамилия*",
      email: "Имейл*",
      phone: "Телефон*",
      message: "Съобщение",
    },
    errors: {
      firstNameRequired: "Името е задължително",
      lastNameRequired: "Фамилията е задължителна",
      emailRequired: "Имейлът е задължителен",
      emailInvalid: "Невалиден имейл адрес",
      phoneRequired: "Телефонният номер е задължителен",
      phoneInvalid: "Невалиден телефонен номер",
    },
    toasts: {
      validationError: {
        title: "Грешка при валидация",
        description: "Моля, попълнете правилно всички задължителни полета.",
      },
      success: {
        title: "Съобщението е изпратено!",
        description: "Ще се свържем с вас възможно най-скоро.",
      },
      error: {
        title: "Грешка",
        description: "Неуспешно изпращане на съобщението. Моля, опитайте отново по-късно.",
      },
    },
    submit: {
      idle: "Изпрати",
      loading: "Изпращане...",
    },
    privacy: {
      prefix: "С изпращането на формата се съгласявате с нашата",
      linkLabel: "Политика за поверителност",
      suffix: ".",
    },
  },
};

export default home;

